import React from 'react'

export default function EmailDetailsIcon() {
    return (

        <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gray-100 rounded-full p-2">  {/* Apply Tailwind classes here */}
            <svg
                width="100%"  // Let SVG inherit size from parent container
                height="100%" // Same for height
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_6_130)">
                    <path d="M22.5 22.5915L12.4239 14.5898H32.576L22.5 22.5915ZM22.5 24.9929C22.2681 24.9929 22.0361 24.9167 21.8442 24.7641L10.3711 15.6533V29.8169C10.3711 30.144 10.6372 30.4102 10.9644 30.4102H34.0356C34.3628 30.4102 34.6289 30.144 34.6289 29.8169V15.6532L23.1558 24.7642C22.9638 24.9167 22.7319 24.9929 22.5 24.9929ZM45 6.89001V38.1101C45 41.9091 41.9091 45 38.11 45H6.89001C3.09085 45 0 41.9091 0 38.11V6.89001C0 3.09085 3.09085 0 6.89001 0H38.1101C41.9091 0 45 3.09085 45 6.89001ZM36.7383 15.1831C36.7383 13.6928 35.5259 12.4805 34.0356 12.4805H10.9644C9.47408 12.4805 8.26172 13.6928 8.26172 15.1831V29.8169C8.26172 31.3072 9.47408 32.5195 10.9644 32.5195H34.0356C35.5259 32.5195 36.7383 31.3072 36.7383 29.8169V15.1831Z" fill="#FFB743" />
                </g>
                <defs>
                    <clipPath id="clip0_6_130">
                        <rect width="45" height="45" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}
